import PropTypes from 'prop-types';
import React from 'react';
import { Bell } from 'react-feather';
import { Link, useLocation } from 'react-router-dom';
import { Logo2 } from './components/Logo2';
import { UserNavigation } from './components/UserNavigation';
import { useDarkMode } from 'hooks/useDarkMode';
import { Text } from 'components/Elements';
import { Sidebar } from './components/Sidebar';
import { Search } from './components/Search';
import { SystemCurrency } from '.';

export const MainLayout = ({ children }) => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  return (
    <div className="h-screen flex flex-col transition-all dark:bg-gray-800 dark:text-white">
      {/* Fixed Navbar */}
      <div className="fixed top-0 left-0 right-0 z-50 px-12 py-1 mt-4">
        <div className="rounded-full flex flex-row items-center justify-between px-6 py-2 bg-gray-800 shadow-md">
          {/* Logo Section */}
          <div className="flex items-center space-x-2">
            <Logo2 />
            <div className="h-6 w-px bg-gray-500"></div>
            <span className="text-white text-lg font-semibold">Finance</span>
          </div>

          <Search />

          {/* Right Section */}
          <div className="flex items-center space-x-1 text-white">
           <SystemCurrency />

            <Link
              to="."
              className="bg-gray-800 shadow-lg dark:bg-gray-700 rounded-full p-4"
            >
              <Bell className="text-white" size={20} />
            </Link>
            <UserNavigation />
          </div>
        </div>
      </div>

      {/* Main Content with padding to offset fixed navbar */}
      <main className="flex-1 overflow-y-auto pt-24 relative">
        <Sidebar />
        {children}
      </main>

      {/* Footer */}
      <footer className="flex flex-col items-center justify-center py-4 text-xs">
        <Text variant="caption">
          © {currentYear}, Wire24. All rights reserved.
        </Text>
        <div className="flex space-x-2">
          {[
            'terms-and-conditions',
            'privacy-policy',
            'cookie-policy',
            'legal',
          ].map((path, idx) => (
            <React.Fragment key={path}>
              {idx > 0 && <span>|</span>}
              <Link to={`/${path}`} className="hover:underline">
                <Text variant="caption">{path.replace('-', ' ')}</Text>
              </Link>
            </React.Fragment>
          ))}
        </div>
      </footer>
    </div>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
